import { useCallback } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { useStore } from 'hooks/useStore';
import { ErrorFallback } from './ErrorFallback';

export function ErrorBoundary({ children, onError = undefined }) {
  const setHideChrome = useStore((state) => state.setHideChrome);

  const FallbackComponent = useCallback(
    (props) => (
      <ErrorFallback
        {...props}
        onMount={() => setHideChrome(true)}
        onUnmount={() => setHideChrome(false)}
      />
    ),
    [setHideChrome]
  );

  return (
    <ReactErrorBoundary FallbackComponent={FallbackComponent} onError={onError}>
      {children}
    </ReactErrorBoundary>
  );
}
